import React from 'react';
import { Typography } from '@mui/material';
import sanitizeHtml from 'sanitize-html';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import WatchLaterRoundedIcon from '@mui/icons-material/WatchLaterRounded';
import { delimitNumber } from '@src/utils/number';
import { StyledCharacterPreservationReminder } from './index.style';

const formatDate = 'DD/MM/YYYY - HH:mm';

const CharacterPreservationReminder = ({
  packageNameLastOrder,
  lastOrderPackageExpiryDate,
  preservationExpiryDate,
  lockCharacters,
}) => {
  const formattedPreservationExpiryDate = moment(preservationExpiryDate).format(
    formatDate,
  );

  const formatedPackageExpiryDate = moment(lastOrderPackageExpiryDate).format(
    formatDate,
  );
  const { i18n } = useTranslation();
  const { t, language } = i18n;

  return (
    <StyledCharacterPreservationReminder>
      <WatchLaterRoundedIcon className="icon-warning" />
      <Typography
        className="character-preservation-reminder-text"
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(
            t('characterPreservationReminder', {
              packageName: packageNameLastOrder,
              packageExpiryDate: formatedPackageExpiryDate,
              lockCharacters: delimitNumber(lockCharacters, language),
              preservationExpiryDate: formattedPreservationExpiryDate,
            }),
          ),
        }}
      />
    </StyledCharacterPreservationReminder>
  );
};

export default CharacterPreservationReminder;
